"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeCookbookPrivacyMutationOptions = exports.changeCookbookPrivacyMutation = void 0;
const client_1 = require("@apollo/client");
const sharedCookbookUsers_1 = require("../queries/sharedCookbookUsers");
exports.changeCookbookPrivacyMutation = client_1.gql `
  mutation ChangeCookbookPrivacy(
    $id: String!
    $input: ChangeCookbookPrivacyInput!
  ) {
    changeCookbookPrivacy(id: $id, input: $input) {
      __typename
      cookbook {
        __typename
        id
        privacy
        shareId
      }
    }
  }
`;
exports.changeCookbookPrivacyMutationOptions = (variables) => ({
    variables,
    update: store => {
        if (variables.input.privacy === "private") {
            store.writeQuery({
                query: sharedCookbookUsers_1.sharedCookbookUsers,
                variables: {
                    cookbookId: variables.id,
                },
                data: {
                    __typename: "Query",
                    sharedCookbookUsers: {
                        __typename: "SharedCookbookUsersResponse",
                        users: [],
                    },
                },
            });
        }
    },
});
//# sourceMappingURL=ChangeCookbookPrivacy.js.map